import { graphql, compose } from 'react-apollo'
import { Row, Col, Badge, Card, CardBody } from 'reactstrap'
import { QueryTermsOfServiceById, QueryAllTermOfServiceAppsInfo } from '~/queries/public.gql'
import Link from 'next/link'
import { dataUnready } from '~/lib/helpers/dataUnready'
import { filterItemTopics } from '~/lib/helpers/filterItemTopics'
import BreadcrumbBar from '~/components/shared/BreadcrumbBar'
import RelatedDocuments from '~/components/shared/RelatedDocuments'
import CmsHtml from '~/components/shared/CmsHtml'
import Applications from '~/components/tos/Applications'

function TermsHeader ({ apps }) {
  return (
    <Row className='mb-4 pb-3 row-border-bottom align-items-center'>
      <Col className='mt-n1'>
        {apps.map(app => (
          <Link key={app.id} href='/tos/app/[id]' as={`/tos/app/${app.id}`} passHref>
            <Badge color='primary' pill className='mr-1 mt-1'>
              {app.name}
            </Badge>
          </Link>
        ))}
      </Col>
    </Row>
  )
}

function TermsList ({ term, app, showNavigation }) {
  if (!term || !app) {
    return <div>Terms of service not found</div>
  }

  const {
    title,
    body,
    topics,
    relatedDocuments
  } = term

  return (
    <>
      <Col>
        <Row className='mb-2 mb-md-3'>
          <Col>
            <h2>{title}</h2>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card>
              <CardBody>
                {showNavigation &&
                  <TermsHeader
                    id='resource-header'
                    apps={topics}
                  />}
                <Row>
                  <Col>
                    <CmsHtml html={body} />
                  </Col>
                </Row>
                {relatedDocuments.length > 0
                  ? <RelatedDocuments relatedDocuments={relatedDocuments} />
                  : null}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Col>
    </>
  )
}

function TermsOfServiceDetails ({ url, dataTerms, dataApps }) {
  const { unready: unreadyTerms, cms_termOfService: term } = dataUnready(dataTerms, 'cms_termOfService')
  const { unready: unreadyApps, cms_allTermOfServiceTopics: scpApps } = dataUnready(dataApps, 'cms_allTermOfServiceTopics')

  let scpApp = null
  let selectedApp = null
  let results = null
  let showNavigation = null

  const breadcrumbs = [
    { name: 'Terms of Service', href: '/tos' }
  ]

  if (unreadyTerms || unreadyApps) {
    results = unreadyTerms || unreadyApps
  } else {
    let filteredTerm = null

    if (term && term.topics) {
      filteredTerm = filterItemTopics(term, scpApps)
    }

    scpApp = filteredTerm && filteredTerm.topics[0]

    selectedApp = url
    if (selectedApp && scpApp) {
      const result = filteredTerm.topics.find(topic => topic.id === selectedApp)
      scpApp = result || filteredTerm.topics[0]
    }

    if (scpApp) {
      breadcrumbs.push({ name: scpApp.name, href: '/tos/app/[id]', as: `/tos/app/${scpApp.id}` })
      breadcrumbs.push({
        name: filteredTerm.title,
        href: '/tos/[id]',
        as: `/tos/${filteredTerm.id}?topic=${scpApp.id}`
      })
    }

    showNavigation = term.showNavigation

    results = (
      <TermsList
        term={filteredTerm}
        app={scpApp}
        showNavigation={showNavigation}
      />
    )
  }

  return (
    <>
      {showNavigation && <BreadcrumbBar breadcrumbs={breadcrumbs} />}
      <Row>
        {showNavigation &&
          <Col md='3'>
            <Applications scpApp={scpApp && scpApp.id} />
          </Col>}
        {results}
      </Row>
    </>
  )
}

TermsOfServiceDetails.publicAccess = true

TermsOfServiceDetails.getInitialProps = () => ({
  title: 'Terms of Service'
})

const withTermsOfServiceById = graphql(QueryTermsOfServiceById, {
  name: 'dataTerms',
  options: ({ url: { query: { id } } }) => ({
    variables: {
      id
    }
  })
})

const withAllTermsOfServiceAppsInfo = graphql(QueryAllTermOfServiceAppsInfo, {
  name: 'dataApps'
})

export default compose(
  withTermsOfServiceById,
  withAllTermsOfServiceAppsInfo
)(TermsOfServiceDetails)
